import React from 'react'

const Modal = ({ id, modalTitle, modalBody , handleAccept}) => {
    return (


        <div className="modal fade" id={id} tabIndex="-1" aria-labelledby={`${id}Label`} aria-hidden="true">
            <div className="modal-dialog ">
                <div className="modal-content rounded-2">
                    <div className="modal-header">
                        <h1 className="modal-title font accentColor fs-3" id={`${id}Label`}>{modalTitle}</h1>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        {modalBody}
                    </div>
                    <div className="modal-footer">
                        {/* <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button> */}
                        <button type="button" onClick={handleAccept} data-bs-dismiss="modal" className="btn border-0 btn-primary img-btn">Yes</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Modal
